module.exports = __webpack_public_path__ + "img/pdg.828dad8a.svg";